import http from './http'
// @ts-ignore
import * as qs from 'querystring';

export const post = (url: string, params: any) =>
  http.request({
    url: url,
    method: 'post',
    timeout: 1000 * 60,
    data: qs.stringify(params)
  })
export const get = (url: string, params: any) =>
  http.request({
    url: url,
    method: 'get',
    timeout: 1000 * 60,
    params: params
  })